import React from 'react';

interface EvoxImage {
  angleId: string;
  angleDescription: string;
  extColorId: string;
  fullsize: string;
  midsize: string;
  thumbnail: string;
  isMatch?: boolean;
  matchedColorName?: string; // ✅ Add this if you're storing it in parsed data
}

export default function EvoxImages({ images }: { images: EvoxImage[] }) {
  if (!images || images.length === 0) return null;

  const matched = images.find((img) => img.isMatch);
  const others = images.filter((img) => !img.isMatch);

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">Evox Vehicle Images</h2>

      {matched && (
        <div>
          <h3 className="text-sm text-gray-600 mb-1">Matched Exterior Color</h3>
          {matched.matchedColorName && (
            <p className="text-base font-medium text-gray-800 mb-1">{matched.matchedColorName}</p>
          )}
          <img
            src={matched.fullsize}
            alt={matched.angleDescription}
            className="rounded shadow w-full max-w-md"
          />
        </div>
      )}

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
        {others.map((img, i) => (
          <img
            key={i}
            src={img.fullsize}
            alt={img.angleDescription}
            className="rounded border"
          />
        ))}
      </div>
    </div>
  );
}
